import {_utils, observers} from "./utils/_utils.js";
import {_libs} from "./utils/_libs.js";
import {_state, getLocalState} from "./state/state.js";
import {sectionWithSwiper} from "./components/examples/section-with-swiper.js";
import {sectionWithGsap} from "./components/examples/section-with-gsap.js";
import {header} from "./components/header.js";
import {footer} from "./components/footer.js";
import {ourServices} from "./components/blocks/other/our-services.js";
import {testimonials} from "./components/blocks/other/testimonials.js";
import {promotion} from "./components/blocks/other/promotion.js";
import {contactUs} from "./components/blocks/other/contact-us.js";
import {completedJobs} from "./components/blocks/other/completed-jobs.js";
import {serviceFlow} from "./components/blocks/other/service-flow.js";
import {workflow} from "./components/blocks/other/workflow.js";
import {recentWork} from "./components/blocks/other/recent-work.js";
import {vacancies} from "./components/blocks/other/vacancies.js";
import {evolution} from "./components/blocks/other/evolution.js";
import {locations} from "./components/blocks/other/locations.js";
import {directContacts} from "./components/blocks/other/direct-contacts.js";
import {busesArchive} from "./components/buses-archive.js";
import {busesSingle} from "./components/buses-single.js";
import {legalToc} from "./components/legal-toc.js";

document.addEventListener('DOMContentLoaded', async (event) => {
    await Promise.all([
        _libs._lazyLoad(),
        getLocalState(),
        _libs._OverlayScrollbars(),
    ]);

    let isUserInteracted = true;
    _state.interactionEvents.forEach(event => {
        window.addEventListener(event, async () => {
            if (isUserInteracted) {
                isUserInteracted = false;
                await Promise.all([
                    _utils.initOnUserInteraction(),
                    _libs.initOnUserInteraction(),
                ])
                _state.updateState({isUserActive: true});
            }
        });
    });

    await Promise.all([
        legalToc(),
        _utils.init(),
        _libs.init(),
        observers.init(),

        header(),
        footer(),
        ourServices(),
        testimonials(),
        promotion(),
        contactUs(),
        completedJobs(),
        serviceFlow(),
        workflow(),
        recentWork(),
        vacancies(),
        evolution(),
        locations(),
        directContacts(),
        busesArchive(),
        busesSingle(),
    ]).then(async () => {
        await Promise.all([
            _utils.anchorInUrl(),
        ])
    });
});